import { QueryClient } from "@tanstack/react-query";
import { getOrAnalyzeGrammar, updateWordGrammar } from "@/hooks/useFirestore";

/**
 * Background grammar enrichment for batch-added words (AI generate, import).
 * Words save instantly; this fills in wordType/nounInfo/verbInfo afterward.
 * Fire-and-forget — callers should .catch() and log.
 */
export async function enrichGrammarInBackground(
  userId: string,
  words: { wordId: string; hebrew: string }[],
  queryClient: QueryClient
) {
  // Check cache / analyze all words in parallel
  const grammarResults = await Promise.allSettled(
    words.map((w) => getOrAnalyzeGrammar(w.hebrew))
  );

  // Update each word doc with grammar
  for (let i = 0; i < words.length; i++) {
    const result = grammarResults[i];
    if (result.status === "fulfilled" && result.value) {
      const grammar = result.value;
      await updateWordGrammar(
        userId,
        words[i].wordId,
        grammar.wordType,
        grammar.nounInfo,
        grammar.verbInfo,
        grammar.adjectiveInfo
      );
    }
  }

  // Refresh UI so word cards show grammar info
  queryClient.invalidateQueries({ queryKey: ["studySetWords"] });
  queryClient.invalidateQueries({ queryKey: ["words"] });
}
